<template>
  <div class="login">
    <HeaderTop :activeIndex="activeIndex" :is_login="is_login" style="height: 120px;margin-bottom: -180px;"></HeaderTop>
    <div class="login-bannerbox">
      <img src="../assets/login_bg.png" class="bannerbox-banner">

      <div class="loginBox" @keyup.enter="dologin">
        <div class="baseForm">
          <div class="loginBox-title">
            <img src="../assets/login/loginForm_bg.png" class="bg bgColor" alt="">
            <div class="box d-flex d-flex-column d-flex-center">
              <!-- <img
                :src="tenantInfo.logo"
                class="logoImg"> -->
              <p>忘记密码</p>
            </div>
          </div>
          <div class="formDiv">
            <div>
              <p>准考证号：</p>
              <div class="loginBox-input clearfix">
                <img src="../assets/home_icon18.png" class="input-icon">
                <input type="text" class="ipt" placeholder="请输入准考证号" v-model="form.account" />
              </div>
            </div>
            <div>
              <p>手机号：</p>
              <div class="loginBox-input clearfix">
                <img src="../assets/home_icon18.png" class="input-icon">
                <input type="text" class="ipt" placeholder="请输入手机号" v-model="form.phone" />
              </div>
            </div>
            <div>
              <p>验证码：</p>
              <div class="codeBox d-flex d-flex-middle d-flex-between">
                <div class="loginBox-input clearfix" style="width: 240px; ">
                  <img src="../assets/home_icon19.png" class="input-icon">
                  <input type="text" class="ipt" placeholder="请输入验证码" v-model="form.userCode" :maxlength="4"/>
                </div>
                <div style="margin-bottom: 20px;">
                  <img style="height: 40px;" :src="verificationImageUrl" id="img_verifycode" @click="refYzm();"
                    alt="点击刷新验证码" class="yzm">
                </div>
              </div>
            </div>
            
            <div>
              <p>短信验证码：</p>
              <div class="codeBox d-flex d-flex-middle d-flex-between">
                <div class="loginBox-input clearfix" style="width: 240px;">
                  <img src="../assets/home_icon19.png" class="input-icon">
                  <input type="text" class="ipt" placeholder="请输入短信验证码" v-model="form.code" :maxlength="6"/>
                </div>
                <el-button class="codeTxt" @click="sendCode()" :disabled="!!smsSecond">
                  发送验证码
                  <template v-if="smsSecond">({{ smsSecond }})</template>
                </el-button>
                <!-- <p id="sendCodeBtn1" class="codeTxt" @click="sendCode(form.phone)" >
                  发送验证码
                  <template v-if="smsSecond">（{{smsSecond}}）</template>
                </p> -->
              </div>

            </div>

            <div>
              <p>新密码：</p>
              <div class="loginBox-input clearfix">
                <img src="../assets/home_icon19.png" class="input-icon">
                <input type="password" class="ipt" placeholder="请输入新密码" v-model="form.password" />
              </div>
              <span class="tips">密码强度要求： 必须是包含大写字母、小写字母、数字、特殊符号（#?!@$%^&*-.）的6位-20位的组合</span>
            </div>

            <div>
              <p>确认密码：</p>
              <div class="loginBox-input clearfix">
                <img src="../assets/home_icon19.png" class="input-icon">
                <input type="password" class="ipt" placeholder="请再次输入密码" v-model="form.password1" />
              </div>
            </div>

            <button class="loginBox-loginbtn" @click="dologin">提交</button>
            <div class="functionBox d-flex d-flex-middle d-flex-end">
              <a href="javascript:void(0)" @click="toLogin()" class="d-flex d-flex-middle hoverColor"
                style="color: rgb(51, 51, 51);">
                <img src="../assets/login/icon_out.png">
                <p>去登录</p>
              </a>
            </div>
          </div>
        </div>
      </div>

    </div>
    <Footer></Footer>

  </div>
</template>

<script>
import vueQr from "vue-qr";
import HeaderTop from "@/components/HeaderTop.vue";
import Footer from "@/components/Footer.vue";
import { mapState } from "vuex"

export default {
  name: 'Login',
  components: {
    vueQr,
    HeaderTop,
    Footer
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      verificationImageUrl: null,
      intervalTime: null,
      smsSecond: 0,
      form: {
        account: null,
        userCode: null,
        phone: null,
        code: null,
        password: null,
        password1: null,
      },
      user: undefined,
      activeIndex: 'Login',
      is_login: true, // 是否首页
      type: 0,
      verificationImageUrl: ''
    };
  },
  computed: {
    ...mapState(['tenantInfo'])
  },
  created() {
    this.refYzm()
  },
  mounted() {
  },
  destroyed() {
    if (this.intervalTime) {
      clearInterval(this.intervalTime);
    }
  },

  methods: {
    isStrongPassword(pw) {
      if (!pw) return false
      // 必须包含：大写、小写、数字、特殊符号（#?!@$%^&*-.），长度 6-20
      const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#?!@$%^&*\-\.])[A-Za-z\d#?!@$%^&*\-\.]{6,20}$/
      return re.test(pw)
    },
    // 图形验证码
    refYzm() {
      this.form.randomStr = new Date().getTime();
      this.$http.post('/student/pc/common/pictureCode').then(res => {
        this.verificationImageUrl = res
      })
    },

    /**
     * 校验手机号
     */
    validatePhone(value) {
      var isPhone = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
      if (!isPhone.test(value)) {
        return false
      } else {
        return true
      }
    },
    /**
     *  发送验证码
     */
    async sendCode() {
      if (!this.form.phone) {
        this.$message.error('请输入手机号')
        return
      }
      if (!this.validatePhone(this.form.phone)) {
        this.$message.error('请输入合法手机号')
        return
      }
      if (!this.form.userCode) {
        this.$message.error('请输入图形验证码')
        return
      }
      this.$http.post('/student/pc/common/getPhoneCheckCode', this.form).then(() => {
        this.$message.success('短信发送成功')
        if (this.intervalTime) {
          this.intervalTime = null
          clearInterval(this.intervalTime);
        }
        this.smsSecond = 90
        this.intervalTime = setInterval(() => {
          if (this.smsSecond === 0) {
            clearInterval(this.intervalTime)
          } else {
            this.smsSecond--
          }
        }, 1000)
      })
    },
    dologin() {
      if (!this.form.account) {
        this.$message.error('准考证号不能为空')
        return;
      }
      if (!this.form.phone) {
        this.$message.error('手机号不能为空')
        return;
      }
      if (!this.form.code) {
        this.$message.error('短信验证码不能为空')
        return;
      }
      if (!this.form.password) {
        this.$message.error('新密码不能为空')
        return;
      }
      if (!this.isStrongPassword(this.form.password)) {
        this.$message.error('新密码必须为6-20位，且包含大写字母、小写字母、数字、特殊符号（#?!@$%^&*-.）')
        return
      }
      if (!this.form.password1) {
        this.$message.error('确认密码不能为空')
        return
      }
      if (this.form.password !== this.form.password1) {
        this.$message.error('两次输入密码不一致')
        return;
      }
      this.$http.post('/student/pc/resetPassword', this.form).then(async (res1) => {
        this.$message.success('操作成功')
        this.toLogin()
      })
    },
    toLogin() {
      this.$router.push({
        path: '/login'
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.form-item-text {
  width: 100px;
}

.clearfix::after {
  content: "";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}

.login {
  .yzm {
    width: 90px;
    height: 50px;
    float: left;
    display: block;
  }

  .login-bannerbox {
    position: relative;
    overflow: hidden;
    margin-top: 180px;

    .bannerbox-banner {
      border: none;
      vertical-align: top;
    }

    .loginBox {
      box-sizing: border-box;
      padding: 78.5px 0;
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;

      .baseForm {
        width: 440px;
        background: #FFFFFF;
        box-shadow: 0px 3 10px 0px rgba(205, 205, 205, 0.25);
        border-radius: 10px;
        overflow: hidden;
        margin: 0 auto;
        position: relative;
        z-index: 2;

        .loginBox-title {
          .bgColor {
            background-color: #0065BA;
          }

          .box {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            z-index: 22;
            text-align: center;

            p {
              font-weight: bold;
              font-size: 16px;
              color: #FFFFFF;
              margin-bottom: 0;
            }
          }

          .logoImg {
            width: 66px;
            height: 66px;
            border-radius: 50%;
            display: block;
            margin: 0 auto 10px auto;
          }
        }

        .formDiv {
          box-sizing: border-box;
          padding: 40px;

          .loginBox-input {
            width: 360px;
            height: 40px;
            background: #F2F2F2;
            border-radius: 20px;
            box-sizing: border-box;
            padding: 10px 20px;
            border: 0;

            .input-icon {
              width: 14px;
              height: 14px;
              margin: 2px 10px 0 0;
            }

            input {
              flex: 1;
              height: 20px;
              line-height: 20px;
              border: none;
              outline: none;
              background: transparent;
              font-size: 16px;
              color: #333;
            }
          }

          .tips {
            display: block;
            margin-top: -10px;
            margin-bottom: 10px;
            line-height: 18px;
            font-size: 12px;
            word-break: break-all;
            color: #999;
          }

          .codeTxt {
            width: 126px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #F2F2F2;
            border-radius: 20px;
            
            margin-left: 4px;
            font-size: 15px;
            color: #333;
            box-sizing: border-box;
            padding: 0 10px;
            margin-bottom: 20px;
          }
        }
      }

      .loginBox-loginbtn {
        background-color: #0065BA;
        border-radius: 20px;
        width: 100%;
        height: 38px;
        border: none;
        outline: none;
        cursor: pointer;
        color: #ffffff;
        font-size: 14px;
        margin-bottom: 20px;
      }

      .password-retrieve {
        font-size: 13px;
        cursor: pointer;
        line-height: 30px;
        text-align: center;
        color: #005599;
      }

      .functionBox a p {
        color: #999;
        margin: 0 0 0 5px;
      }
    }
  }

  .loging-notice {
    padding: 30px 0 20px 0;

    .notice-mid {
      width: 1200px;
      margin: 0 auto;

      .notice-mid-logo {
        background: url('../assets/home_icon03.png') no-repeat;
        width: 342px;
        height: 86px;
        background-size: 100% 100%;
        box-sizing: border-box;
        padding-left: 70px;
        float: left;
        font-size: 24px;
        line-height: 86px;
        color: #ffffff;

        img {
          width: 30px;
          height: 30px;
          vertical-align: text-bottom;
          margin-right: 15px;
        }
      }

      .notice-mid-title {
        border-left: 5px solid #ffa400;
        padding: 15px 20px;
        background-color: #ffffff;
        box-shadow: 0px 0px 20px rgba(221, 221, 221, 0.6);
        height: 86px;
        box-sizing: border-box;
        float: left;
        width: 850px;
        margin-left: 8px;
        float: left;
        cursor: pointer;

        .title-text {
          font-size: 16px;
          line-height: 32px;
          color: #333333;
          display: block;
          font-weight: normal;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .title-text:hover {
          color: #1965a2;
        }

        .title-time {
          font-size: 13px;
          color: #666666;
          line-height: 24px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .notice-information {
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      margin-top: 15px;

      .information {
        width: 590px;
        box-sizing: border-box;
        box-shadow: 0px 0px 20px rgba(221, 221, 221, 0.6);
        padding: 10px 30px;
        background-color: #ffffff;

        .information-news {
          font-size: 16px;
          color: #333333;
          line-height: 48px;
          margin-bottom: 15px;
          border-bottom: 1px solid #dddddd;

          .news {
            display: inline-block;
            vertical-align: middle;
            margin-bottom: 2px;
            margin-right: 10px;
          }

          .more {
            display: block;
            float: right;
            font-size: 14px;
            color: #999;
          }
        }

        .information-list:nth-child(4),
        .information-list:nth-child(2),
        .information-list:nth-child(3) {
          span {
            background-color: #1965a2;
            color: #ffffff;
          }
        }

        .information-list {
          padding: 5px;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          .information-serial {
            background-color: #dcdcdc;
            color: #999;
            width: 24px;
            height: 24px;
            text-align: center;
            line-height: 24px;
            font-size: 16px;
            margin-right: 10px;
            display: inline-block;
            border-radius: 50%;
          }

          .information-content {
            color: #333333;
            font-size: 16px;
            line-height: 36px;
            display: inline-block;
            cursor: pointer;
          }

          .information-content:hover {
            color: #1965a2;
          }
        }
      }
    }
  }

  .login-order {
    background-color: #ffffff;
    padding: 40px 0;

    .order-mid {
      width: 1200px;
      margin: 0 auto;

      .order-title {
        background-color: #d7e7f4;
        border-radius: 0px 40px 0px 0px;
        line-height: 56px;
        color: #3a77a8;
        font-size: 24px;
        font-weight: bold;
        padding: 0 50px 0 40px;
        display: inline-block;

        .order-icon {
          display: inline-block;
          width: 22px;
          vertical-align: middle;
          margin-bottom: 2px;
          margin-right: 10px;
        }
      }

      .order-chart {
        padding: 40px 50px;
        background-color: #d7e7f4;

        .lcconTop {
          display: flex;
          justify-content: space-between;

          p {
            margin: 0;
            width: 70px;
            height: 40px;
            margin-top: 38px;
            line-height: 40px;
            text-align: center;
            color: #ffffff;
            font-weight: bold;
          }
        }

        .lcconMiddle {
          height: 9px;
          background-color: #fff;
          margin: 20px 30px;
          position: relative;

          .lcconMiddleCircle1 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #3a77a8;
            border-radius: 50%;
            left: -0.4%;
            top: -4px;
          }

          .lcconMiddleCircle2 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #d9d9d9;
            border-radius: 50%;
            left: 12%;
            top: -4px;
          }

          .lcconMiddleCircle3 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #ffa400;
            border-radius: 50%;
            left: 24.4%;
            top: -4px;
          }

          .lcconMiddleCircle4 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #3a77a8;
            border-radius: 50%;
            left: 36.8%;
            top: -4px;
          }

          .lcconMiddleCircle5 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #d9d9d9;
            border-radius: 50%;
            left: 49.2%;
            top: -4px;
          }

          .lcconMiddleCircle6 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #ffa400;
            border-radius: 50%;
            left: 61.5%;
            top: -4px;
          }

          .lcconMiddleCircle7 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #3a77a8;
            border-radius: 50%;
            left: 74%;
            top: -4px;
          }

          .lcconMiddleCircle8 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #d9d9d9;
            border-radius: 50%;
            left: 86.3%;
            top: -4px;
          }

          .lcconMiddleCircle9 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #ffa400;
            border-radius: 50%;
            left: 98.7%;
            top: -4px;
          }

          .lcconMiddleLine {
            border-bottom: 1px dashed #d9d9d9;
            padding-top: 4px;
          }
        }

        .lcconBottom {
          display: flex;
          justify-content: space-between;

          p {
            margin: 0;
            width: 70px;
            height: 40px;
            margin-bottom: 38px;
            line-height: 40px;
            text-align: center;
            color: #ffffff;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
